import Head from 'next/head'
import { FC } from 'react'

import { GAHead } from '../../global/analytics/google-head'
import { YABody } from '../../global/analytics/yandex-head'
import { AMHead } from '../../global/analytics/amplitude-head'
import { PixelHead, PixelBody } from 'components/global/analytics/vk-pixel-head'

import { STATIC_URL, YM_ID } from 'constants/data'

const faviconPath = `${STATIC_URL}/favicon`
const Icon = {
  appleTouch: `${faviconPath}/apple-touch-icon.png`,
  favicon32: `${faviconPath}/favicon-32x32.png`,
  favicon16: `${faviconPath}/favicon-16x16.png`,
  webmanifest: `${faviconPath}/site.webmanifest`,
  safari: `${faviconPath}/safari-pinned-tab.svg`,
}

const AppHead: FC = () => {
  return (
    <>
      <GAHead />
      <AMHead />
      <PixelHead />

      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <meta name="yandex-verification" content="01595f6a5793ecc4" />
        <meta
          name="google-site-verification"
          content="BLj6b-v2dtXJshwCnJ6UvDBqgdNqCJAXCjk1qokLvoY"
        />
        <meta name="apple-mobile-web-app-status-bar-style" content="#333333" />
        <link rel="apple-touch-icon" sizes="180x180" href={Icon.appleTouch}></link>
        <link rel="icon" type="image/png" sizes="32x32" href={Icon.favicon32}></link>
        <link rel="icon" type="image/png" sizes="16x16" href={Icon.favicon16}></link>
        <link rel="manifest" href={Icon.webmanifest}></link>
        <link rel="mask-icon" href={Icon.safari} color="#5bbad5"></link>
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />

        <link rel="preconnect" href="https://firebase.googleapis.com"></link>
        <link rel="preconnect" href="https://www.gstatic.com"></link>
        <link rel="preconnect" href="https://cdn.amplitude.com"></link>

        <meta property="og:type" content="website" />

        <YABody />
        {/* <YAHead /> */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

          ym(${YM_ID}, "init", {
              defer: true,
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true,
              webvisor:true
          });

          `,
          }}
        ></script>
        <style
          dangerouslySetInnerHTML={{
            __html: `
.varioqub-antiflicker {opacity: 0 !important;}
          `,
          }}
        ></style>
        <script
          dangerouslySetInnerHTML={{
            __html: `
          (function(a,n,t,i,f,li,c,k,e,r){
                a[t]=a[t]||function(){(a[t].a=a[t].a||[]).push(arguments)};n.classList.add(i);c=function(){n.classList.remove(i)};li.callback=c;a[t].antiFlicker=li;setTimeout(c,f);
            })(window, document.documentElement, 'ymab', 'varioqub-antiflicker', 500, { 'metrika.<YOUR_COUNTER_ID>': true });

          `,
          }}
        ></script>
        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
     (function(e, x, pe, r, i, me, nt){
      e[i]=e[i]||function(){(e[i].a=e[i].a||[]).push(arguments)},
      me=x.createElement(pe),me.async=1,me.src=r,nt=x.getElementsByTagName(pe)[0],me.addEventListener('error',function(){function cb(t){t=t[t.length-1],'function'==typeof t&&t({flags:{}})};Array.isArray(e[i].a)&&e[i].a.forEach(cb);e[i]=function(){cb(arguments)}}),nt.parentNode.insertBefore(me,nt)})
      (window, document, 'script', 'https://abt.s3.yandex.net/expjs/latest/exp.js', 'ymab');
      ymab('metrika.${YM_ID}', 'init'/*, {clientFeatures}, {callback}*/);
          `,
          }}
        ></script>

        {/* работа с флагами */}
        {/* <script
          dangerouslySetInnerHTML={{
            __html: `
            ymab('metrika.${YM_ID}', 'getFlags', (flags) => {
              for (const [key, value] of Object.entries(flags)) {
                // console.log('AB Flags in head:', key, value);
                }
              window.dispatchEvent(new CustomEvent('yandexABFlagsLoaded', { detail: flags }));
              localStorage.setItem('AB_FLAGS', flags.new_bar[0] === 'new' ? 'new' : 'old');
              });
          `,
          }}
        ></script> */}

        <PixelBody />
        <script src="https://pay.yandex.ru/sdk/v1/pay.js" async></script>
      </Head>
    </>
  )
}

export default AppHead
